import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import { IconX } from "@tabler/icons-react"

interface OptionClearSelectionButtonProps {
  onClear: () => void
  disabled?: boolean
  ariaLabel?: string
}

export const OptionClearSelectionButton: React.FC<
  OptionClearSelectionButtonProps
> = ({ onClear, disabled = false, ariaLabel }) => {
  const { translate } = useTranslation()
  const resolvedAriaLabel =
    ariaLabel ?? translate("QUESTIONNAIRE_ANSWERS/CLEAR_OPTION_SELECTION")
  return (
    <button
      type="button"
      aria-label={resolvedAriaLabel}
      onMouseDown={(e) => {
        e.preventDefault()
        e.stopPropagation()
      }}
      onClick={(e) => {
        e.preventDefault()
        e.stopPropagation()
        if (!disabled) {
          onClear()
        }
      }}
      disabled={disabled}
      className="rounded p-1 text-muted-foreground transition-colors hover:bg-secondary hover:text-foreground disabled:cursor-not-allowed disabled:opacity-50"
    >
      <IconX size={16} stroke={1} aria-hidden="true" />
    </button>
  )
}
